// extracted by mini-css-extract-plugin
module.exports = {"skipLinkItem":"skip-link-skipLinkItem--3e6cf","skipLink":"skip-link-skipLink--05237"};